export const defaultLinkStyle = "text-brand-600 hover:underline";

export const defaultLinkColour = "text-brand-600";
